module.exports = __webpack_public_path__ + "img/belgium-eye-and-ear-diseases-female.489a0d10.png";